import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { NgSelectModule } from "@ng-select/ng-select";
import { CloComponent } from "./components/clo/clo.component";
import { CloGraphComponent } from "./components/clo-graph/clo-graph.component";
import { CloLiteComponent } from "./components/clo-lite/clo-lite.component";
import { CloLiteGraphComponent } from "./components/clo-lite-graph/clo-lite-graph.component";
import { ChartdataDynaDimmerComponent } from "./components/chartdata-dyna/chartdata-dyna.component";
import { SampledynagraphComponent } from "./components/sampledynagraph/sampledynagraph.component";
import { SamplegraphdynanontimeComponent } from "./components/samplegraphdynanontime/samplegraphdynanontime.component";
import { DynadimmerGraphtoggleComponent } from "../dynadimmer-graphtoggle/dynadimmer-graphtoggle.component";
import { RsoComponent } from "../rso/rso.component";
import { LipComponent } from "../lip/lip.component";
import { OnlynumberDirective } from "./directive/onlynumber.directive";
import { DefaultFeatureViewComponent } from "./components/default-feature-view/default-feature-view.component";

@NgModule({
  declarations: [
    CloComponent,
    CloGraphComponent,
    CloLiteComponent,
    CloLiteGraphComponent,
    ChartdataDynaDimmerComponent,
    SampledynagraphComponent,
    SamplegraphdynanontimeComponent,
    DynadimmerGraphtoggleComponent,
    RsoComponent,
    LipComponent,
    DefaultFeatureViewComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxSliderModule,
    NgSelectModule,
    OnlynumberDirective,
  ],
  exports: [
    CloComponent,
    CloGraphComponent,
    CloLiteComponent,
    CloLiteGraphComponent,
    ChartdataDynaDimmerComponent,
    SampledynagraphComponent,
    SamplegraphdynanontimeComponent,
    DynadimmerGraphtoggleComponent,
    RsoComponent,
    LipComponent,
    DefaultFeatureViewComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxSliderModule,
    NgSelectModule,
  ],
})
export class FeatureConfigurationSharedModule {}
